// @flow

import React from 'react';
import styled from 'styled-components';

import {BieBackDrop} from './BieBackDrop';
import {BieFader} from './BieFader';

const StyledLoaderDiv = styled.div`
  padding: 10px 16px;
  border: 1px solid rgba(0, 0, 0, 0.5);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 1px 1px rgba(0, 0, 0, 0.16),
    0 -1px 3px rgba(0, 0, 0, 0.12), 0 -1px 1px 1px rgba(0, 0, 0, 0.16);
  background: #fff;
  border-radius: 5px;
`;

export const BieLoader = () => (
  <StyledLoaderDiv>
    <i className="fas fa-circle-notch fa-spin" /> Loading...
  </StyledLoaderDiv>
);

type BieLoaderModalType = {
  show: boolean,
};

export const BieLoaderModal = ({show}: BieLoaderModalType) => (
  <BieFader in={show}>
    <BieBackDrop>
      <BieLoader />
    </BieBackDrop>
  </BieFader>
);
